export default [
  {
    path: "/",
    redirect: "/home",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/home",
    component: () => import("@/views/home/Home.vue")
  },
  {
    path: "/login",
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: "/login-test",
    component: () => import("@/views/loginTest/LoginTest.vue")
  },
  {
    path: "/drawer",
    component: () => import("@/views/Drawer.vue")
  },
  {
    path: "/order",
    component: () => import("@/views/order/Orders.vue")
  },
  {
    path: "/request-delivery",
    component: () => import("@/views/delivery/Delivery.vue")
  },
  {
    path: "/appointment",
    component: () => import("@/views/home/Appointment/appointment.vue")
  },
  {
    path: "/recover",
    component: () => import("@/views/recover/Recover.vue")
  },
  // {
  //   path: '/recover_confirm',
  //   component: () => import('@/views/recover/confirm-recover/Recover_confirm.vue')
  // },
  {
    // Always leave this as last one
    path: "*",
    component: () => import("@/views/404/404.vue")
  }
];
